export enum ERoles {
    ADMIN = 'ADMIN',
    USER = 'USER',
    ORGANIZATION_MANAGER = 'ORGANIZATION_MANAGER',
}
